import { useLazyIndexedDBGraphqlQuery } from '@repo/services';
import { TenantFeatureConfigurationFeatureName } from '@repo/utils';
import { useEffect } from 'react';

import {
  getTenantFeatureConfiguration,
  type GetTenantFeatureConfigurationType,
} from '../queries/tenantFeatureConfiguration';

export const useFetchTenantFeatureConfiguration = ({
  skip = false,
}: {
  skip?: boolean;
} = {}): {
  tenantFeatureConfiguration: GetTenantFeatureConfigurationType | null;
  isLoading?: boolean;
  fetchTenantFeatureConfiguration: any;
} => {
  const featuresToFetch = Object.values(TenantFeatureConfigurationFeatureName);

  const [fetchTenantFeatureConfiguration, {
    data: tenantFeatureConfiguration,
    isLoading,
    error,
  }] = useLazyIndexedDBGraphqlQuery<GetTenantFeatureConfigurationType>({
    cacheKey: `tenantFeatureConfiguration-${featuresToFetch.join(',')}`,
    document: getTenantFeatureConfiguration,
    variables: {
      featureName: featuresToFetch,
    },
  });

  useEffect(() => {
    if (error) { return; }

    if (!skip && !isLoading && !tenantFeatureConfiguration) {
      fetchTenantFeatureConfiguration({ document: getTenantFeatureConfiguration });
    }
  }, [fetchTenantFeatureConfiguration, skip, tenantFeatureConfiguration, isLoading, error]);

  return {
    fetchTenantFeatureConfiguration,
    tenantFeatureConfiguration: tenantFeatureConfiguration!,
    isLoading,
  };
};
